module.exports = __webpack_public_path__ + "img/star_01.77750744.png";